export default __webpack_public_path__ + "static/media/You-Rock.5b6f9dbe.gif";